import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../../core/services/notification.service';
import {BaseGeneral} from '../../_utils/BaseGeneral';
import {BodyService} from '../../_utils/body.service';
import {JsonApiService} from '../../../core/api/json-api.service';
import {AuthenticationService} from '../../../+auth/+login/authentication.service';

declare var $:any;

@Component({
  selector: 'sa-logout',
  template: `
<div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title={{title}} data-action="userLogout"
                  data-logout-msg="Esta seguro de salir del Sistema?"><i
          class="fa fa-sign-out"></i></a> </span>
    </div>
  `,
  styles: []
})
export class LogoutComponent extends BaseGeneral {
 title : string;
 titleQuestion : string;
 question : string;
 option1 : string;
 option2 : string;
  constructor(
              private authenticationService: AuthenticationService,
              protected router: Router,
              protected notificationService: NotificationService,
              protected bodyService: BodyService,
              protected jsonApiService: JsonApiService) {
    super(router, bodyService, notificationService, jsonApiService);
    this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
    this.title = this.datai18n['Header.signOut'];
    this.titleQuestion = this.datai18n['Header.signOut.titleQuestion'];
    this.question = this.datai18n['Header.signOut.question'];
    this.option1 = this.datai18n['Header.signOut.question.option1'];
    this.option2 = this.datai18n['Header.signOut.question.option2'];
  }

  showPopup(){
    this.notificationService.smartMessageBox({
      title : "<i class='fa fa-sign-out txt-color-orangeDark'></i>&nbsp;"+this.titleQuestion+"<span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span> ?",
      content : this.question,
      buttons : '['+this.option2+']['+this.option1+']'

    }, (ButtonPressed) => {
      if (ButtonPressed == this.option1) {
        this.logout()
      }
    });
  }

  logout(){
      // debugger;
      if(JSON.parse(sessionStorage.getItem('selectModule'))){
           this.router.navigate(['home']);
      }
      else{
        this.authenticationService.logout();
        this.router.navigate(['/auth/login']);
        window.location.reload();
        
      }

  }

  ngOnInit() {

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts